import KeyMirror from 'keymirror';

const InteractionStudioCodes = KeyMirror(
  {
    MYB_ANCILLARY_PERSONALIZATION: null,
    MYB_ANCILLARY_PERSONALIZATION_CONTROL: null,
    TRAKING_IMPRESSION: null,
  }
);

export default InteractionStudioCodes;